<template>
<div>
  <div class="wistia_embed wistia_async_408my2yurh">
    &nbsp;
  </div>

  <div
    id="scenarios"
    class="tbk-vid-embed"
  >
    <a
      id="phishing"
      class="embedded_video"
      href="#wistia_6sspz2rq2l?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="id_theft"
      class="embedded_video"
      href="#wistia_909h78spmn?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="business_email"
      class="embedded_video"
      href="#wistia_0wugcggou9?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('408', 49, this.showScenarios)
    this.tbk.loadCrossTime('6ss', 218, this.showScenarios)
    this.tbk.loadCrossTime('909', 257, this.showScenarios)
    this.tbk.loadCrossTime('0wu', 247, this.showScenarios)

    if (this.tbk.isMobile()) {
      _wq.push({
        408: this.tbk.autoPlay,
        '6ss': this.tbk.autoPlay,
        909: this.tbk.autoPlay,
        '0wu': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showScenarios() {
      $('#scenarios').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#scenarios
  display: none
  a
    text-decoration: none
#phishing
  position: absolute
  top: calc(100% * (100 / 360))
  left: calc(100% * (50 / 640))
  width: calc(100% * (165 / 640))
  height: calc(100% * (190 / 360))
#id_theft
  position: absolute
  top: calc(100% * (100 / 360))
  left: calc(100% * (240 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (190 / 360))
#business_email
  position: absolute
  top: calc(100% * (100 / 360))
  left: calc(100% * (425 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (190 / 360))
</style>

